import { BaseRemittanceHistory } from './base-remittance-history';

export class ScheduledRemittanceHistory extends BaseRemittanceHistory {
  public scheduledRemittanceId!: number;
}
